import { render, staticRenderFns } from "./AdminTab.vue?vue&type=template&id=3ad5ac6d&scoped=true"
import script from "./AdminTab.vue?vue&type=script&lang=js"
export * from "./AdminTab.vue?vue&type=script&lang=js"
import style0 from "./AdminTab.vue?vue&type=style&index=0&id=3ad5ac6d&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad5ac6d",
  null
  
)

export default component.exports